import {connect} from 'react-redux';
import {UNREFINED_KEY} from '../../utils/listings';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import GreatPlacesToStayComponent from './GreatPlacesToStay';
import {moduleLoaded, moduleHidden} from '../../reducers/moduleStatus';

function mapStateToProps({
    destination,
    abacus,
    greatPlaces,
    config,
    modules: {searchMessages},
}) {
    const {
        segmentFilters: {key = UNREFINED_KEY},
        segments,
        details: {location, lbsId},
    } = destination;
    const isSegment = key !== UNREFINED_KEY && segments.length;
    const inventoryCount = isSegment
        ? segments.find((segment) => segment.messageKey === key).count
        : destination.inventoryCount;

    return {
        listings: destination.listings,
        highlightedId: greatPlaces.highlightedId,
        inventoryCount,
        segmentKey: key,
        propertyType: destination.propertyType,
        isRefined: config.isRefined,
        abacus,
        segmentFilters: destination.segmentFilters,
        serpUrlFilters: destination.serpUrlFilters,
        mapTitle: searchMessages.title,
        title: greatPlaces.title,
        lastCardUrl: destination.lastCardUrl,
        destinationLocation: location,
        lbsId,
    };
}

export const mapDispatchToProps = {moduleLoaded, moduleHidden};

export const GreatPlacesToStay = connect(
    mapStateToProps,
    mapDispatchToProps
)(determineIfMobile(GreatPlacesToStayComponent));

GreatPlacesToStay.displayName = 'GreatPlacesToStay';

export default GreatPlacesToStay;
